
import { STOCK_ORDER_MENU_ITEM } from "@/consts";
import StockOrderTable from "@/components/barcodeSystem/stockOrder/StockOrderTable.vue";
import StockOrderFilters from "@/components/barcodeSystem/stockOrder/StockOrderFilters.vue";
import StockOrdersActions from "@/components/barcodeSystem/stockOrder/StockOrdersActions.vue";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import StockOrderModule from "@/store/modules/barcodeSystem/stockOrder";
import Component from "vue-class-component";
import permissions from "@/security/permissions";

const stockOrderModuleState = getModule(StockOrderModule);

@Component({
  components: {
    StockOrderTable,
    StockOrderFilters,
    StockOrdersActions
  }
})
export default class StockOrderSearch extends Vue {
  showStockOrderFieldFilter: boolean = false;
  truckMenuStyle: string = "";
  STOCK_ORDER_MENU_ITEM: any = STOCK_ORDER_MENU_ITEM;

  get fields() {
    return stockOrderModuleState.fields;
  }

  async created() {
  }
  
  async loadMoreOrders() {
    await stockOrderModuleState.setLoading(true);
    await stockOrderModuleState.getStockOrders(null);
    await stockOrderModuleState.setLoading(false);
  }

  async onSort(s) {
    await stockOrderModuleState.setLoading(true);
    await stockOrderModuleState.applyListSort(s);
    await stockOrderModuleState.setLoading(false);
  }

  toggleChangeField(idx, hideShow) {
    stockOrderModuleState.toggleField({ idx: idx, value: !hideShow });
  }

  get menuItemsToDisplay() {
    return this.STOCK_ORDER_MENU_ITEM.filter(
      x => (x.requiresPermission === undefined || this.hasPermission(x.requiresPermission)) && 
           (x.requiresPermission != permissions.barcodeSystem.stockOrders.cancel || (stockOrderModuleState.getSelectedItems.every(x => x.isOpen) && stockOrderModuleState.getSelectedItems.every(x => !x.isLocked))) && 
           (x.requiresPermission != permissions.barcodeSystem.stockOrders.unlock || stockOrderModuleState.getSelectedItems.every(x => x.isLocked))
    );
  }

  get dataRetreived() {
    if(stockOrderModuleState.data)
      return true;
    return false;
  }
}


